const validateAmount = /^[1-9][0-9]*(,[0-9]+)?$/;

export default validateAmount;
